import type { FunctionComponent } from 'react';

import styles from './InputErrors.less';

export const InputErrors: FunctionComponent<{
  errors: string[] | null;
}> = ({ errors }) => {
  if (!errors) {
    return null;
  }

  const errorElements = errors.map((error, index) => (
    // eslint-disable-next-line @eslint-react/no-array-index-key -- FIXME
    <p key={`error-${index}`}>{error}</p>
  ));

  return <div className={styles.inputErrors}>{errorElements}</div>;
};
